__webpack_require__.p = "https://pg-prod.mynd-cdn.com/4.2.6/public/bundles/";